import { getAuth } from "firebase/auth";
import axios from "axios";

interface TokenData {
  token: string;
  expiresAt: number;
}

const storeToken = (token: string) => {
  try {
    const decodedToken = JSON.parse(atob(token.split(".")[1]));
    const expiresAt = decodedToken.exp * 1000; // Convert to milliseconds
    const tokenData: TokenData = {
      token,
      expiresAt,
    };
    sessionStorage.setItem("firebase_token", JSON.stringify(tokenData));
  } catch (error) {}
};

const getStoredToken = () => {
  try {
    const storedData = sessionStorage.getItem("firebase_token");
    return storedData ? JSON.parse(storedData) : null;
  } catch (error) {
    return null;
  }
};

export const getValidToken = async (usePopupMode: boolean = true) => {
  try {
    // Check if user has been logged in for more than 12 hours
    // const canContinue = await checkLoginTime(usePopupMode);
    // if (!canContinue) {
    //   return null; // User session exceeded 12 hours, cache cleared and logged out
    // }

    const storedTokenData = getStoredToken();
    const currentTime = Date.now();

    // If we have a stored token and it's not expired (with 5 min buffer)
    if (
      storedTokenData &&
      storedTokenData.expiresAt > currentTime + 5 * 60 * 1000
    ) {
      return storedTokenData.token;
    }

    const auth = getAuth();
    const currentUser = auth.currentUser;

    if (!currentUser) {
      return null;
    }

    // Token is expired or about to expire, get a new one
    const newToken = await currentUser.getIdToken(true);
    storeToken(newToken);
    return newToken;
  } catch (error) {
    throw error;
  }
};

// Store login time when user logs in
export const storeLoginTime = () => {
  const loginTime = Date.now();
  sessionStorage.setItem("user_login_time", loginTime.toString());
};

// Clear all user-related cache and storage
export const clearUserCache = () => {
  // Clear all sessionStorage items related to user session
  const itemsToRemove = [
    "firebase_token",
    "user_login_time",
    "user",
    "accessToken",
    "session_info",
    // Add any other cache keys you want to clear
  ];

  // itemsToRemove.forEach((item) => {
  //   sessionStorage.removeItem(item);
  // });

  // Also clear any localStorage items that might exist
  const localStorageItems = ["user", "accessToken", "firebase_token"];
  localStorageItems.forEach((item) => {
    localStorage.removeItem(item);
  });
};

// Check if session is expired (without clearing)
export const isSessionExpired = (): { expired: boolean; timeLeft: number } => {
  const loginTimeStr = sessionStorage.getItem("user_login_time");

  if (!loginTimeStr) {
    return { expired: false, timeLeft: 0 };
  }

  const loginTime = parseInt(loginTimeStr);
  const currentTime = Date.now();
  const twelveHours = 12 * 60 * 60 * 1000; // 12 hours in milliseconds
  const elapsedTime = currentTime - loginTime;
  const timeLeft = Math.max(
    0,
    Math.floor((twelveHours - elapsedTime) / (60 * 1000))
  ); // in minutes

  return {
    expired: elapsedTime >= twelveHours,
    timeLeft,
  };
};

// Check if user has been logged in for more than 12 hours
const checkLoginTime = async (usePopupMode: boolean = true) => {
  try {
    const loginTimeStr = sessionStorage.getItem("user_login_time");

    if (!loginTimeStr) {
      storeLoginTime();
      return true;
    }

    const loginTime = parseInt(loginTimeStr);
    const currentTime = Date.now();
    const twelveHours = 12 * 60 * 60 * 1000; // 12 hours in milliseconds

    if (currentTime - loginTime > twelveHours) {
      return true;
    }

    return true;
  } catch (error) {
    return true;
  }
};
export const getUserProfile = async () => {
  const url = `${process.env.REACT_APP_API_HOST}users/me`;
  const token = await getValidToken();
  const me = await axios.get(url, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
  if (me.data.isSuccess) {
    sessionStorage.setItem("user", JSON.stringify(me.data.data));
    return me.data.data;
  }
  return null;
};
